/**
 * Uploads are stored as ``{publicCaseId}-{type}.pdf`` (lowercase). Inside a case screen,
 * strip the case prefix so advisors see e.g. ``passport.pdf`` instead of ``sr-12345-passport.pdf``.
 */

export function formatDocumentFilenameForCaseView(filename, publicCaseId) {
  if (!filename) return '';
  const pid = String(publicCaseId || '').trim();
  if (!pid) return String(filename);
  const base = String(filename).replace(/^.*[/\\]/, '');
  const escaped = pid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`^${escaped}-`, 'i');
  return base.replace(re, '') || base;
}
